// extracted by mini-css-extract-plugin
export default {"gameModal":"GameModal_gameModal__jz+-l"};